























































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import SelectOption from "@/components/common/SelectOption";
import ServiceCatalogService from "@/services/ServiceCatalogService";
import SalesOrderService from "@/services/SalesOrderService";
import ServiceCatalogItemDTO from "@/dto/sales/catalog/ServiceCatalogItemDTO";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import { CreatedSalesOrderDTO, CreateSalesOrderPayload } from "@/dto/sales/orders/SalesOrderDTO";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { processError } from "@/utils/ComponentUtils";

@Component({
  components: { SimpleProfileSearch, PortalCheckbox, PortalSelect, PortalInput }
})
export default class CreateSalesOrderModal extends Vue {
  @Prop() onSuccess!: () => void;

  private catalogItems: ServiceCatalogItemDTO[] = [];
  private selectedProfile: ProfileDTO | null = null;
  private selectedCatalogItemIds: number[] = [];
  private isCustom = false;
  private customItemDescription = '';
  private customItemAmount: number | null = null;
  private reference = '';
  private sendLink = true;
  private createdOrder: CreatedSalesOrderDTO | null = null;

  async mounted() {
    try {
      const response = await ServiceCatalogService.getCatalog();
      this.catalogItems = response.data;
    } catch (e) {
      processError(e, this);
    }
  }

  get selectOptions(): SelectOption[] {
    return this.catalogItems.map(item => new SelectOption({
      title: item.title,
      value: item.id,
      priceCents: item.actualPrice?.priceCents,
      subscriberPriceCents: item.actualPrice?.subscriberPriceCents
    } as any));
  }

  get isFormValid(): boolean {
    if (!this.selectedProfile) return false;

    if (this.isCustom) {
      return !!this.customItemDescription && this.customItemAmount !== null && this.customItemAmount > 0;
    }

    return this.selectedCatalogItemIds.length > 0;
  }

  private formatPrice(price: any): string {
    if (!price) return 'N/A';
    return `$${(price.priceCents / 100).toFixed(2)}`;
  }

  private onCustomToggle(val: boolean) {
    if (val) {
      this.selectedCatalogItemIds = [];
    }
  }

  async submit() {
    if (!this.selectedProfile) return;

    if (this.$loadOn) this.$loadOn();
    try {
      const payload: CreateSalesOrderPayload = {
        catalogItemIds: this.selectedCatalogItemIds,
        customItem: this.isCustom ? {
          description: this.customItemDescription,
          amount: Math.round((this.customItemAmount || 0) * 100)
        } : null,
        customerId: this.selectedProfile.id,
        customerType: this.selectedProfile.type as unknown as CounterpartyType,
        reference: this.reference || null,
        sendLink: this.sendLink
      };
      const response = await SalesOrderService.createOrder(payload);
      this.createdOrder = response.data;
      if ((this as any).$nts) (this as any).$nts.success("Order created");
    } catch (e) {
      processError(e, this);
    } finally {
      if ((this as any).$loadOff) (this as any).$loadOff();
    }
  }

  close() {
    (this as any).$modal.hideAll();
  }

  closeAndRefresh() {
    if (this.onSuccess) {
      this.onSuccess();
    }
    this.close();
  }
}
